// components/Elements/Accordion.jsx

import React, { useState, createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const AccordionContext = createContext();

export const Accordion = ({ children, defaultOpen = 0 }) => {
  const [openIndex, setOpenIndex] = useState(defaultOpen);

  const toggle = (index) => {
    setOpenIndex(prev => (prev === index ? null : index));
  };

  return (
    <AccordionContext.Provider value={{ openIndex, toggle }}>
      <div className="w-full space-y-4">
        {React.Children.map(children, (child, index) =>
          React.cloneElement(child, { index })
        )}
      </div>
    </AccordionContext.Provider>
  );
};

Accordion.propTypes = {
  children: PropTypes.node.isRequired,
  defaultOpen: PropTypes.number,
};

export const useAccordion = () => useContext(AccordionContext);
